import { Capacitor } from '@capacitor/core';

export const GLOBAL_TASKS_ZENDESK_HELP_URL =
    'https://everwayeu.zendesk.com/hc/en-gb/categories/52865343493779-Global-Tasks';

export function isHelpVisibleForPlatform() {
    return true;
}

/**
 * Opens Zendesk help outside the app WebView (device default browser on native).
 * ponytail: relies on Capacitor Bridge external-URL handling; do not use @capacitor/browser here.
 */
export async function openGlobalTasksHelp() {
    const url = GLOBAL_TASKS_ZENDESK_HELP_URL;
    if (Capacitor.isNativePlatform()) {
        window.location.assign(url);
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
}
